import type { PendingApproval } from "@/api/notifications";
import type { FrameApplyContext } from "@/lib/companion-frame-reducer";
import { applyToolApprovalRequested, endToolApproval } from "./work-toast-tool-approvals";

/** After a restart or reconnect the pending approvals come back as pills, and
 *  a pill whose approval is over (decided, expired or its run ended while
 *  this client was away) leaves. `fetchStartedAt` is taken just before the
 *  summary was requested: an approval that arrived since then can be missing
 *  from that snapshot. */
export function seedWorkToastApprovals(
  approvals: PendingApproval[],
  ctx: FrameApplyContext,
  fetchStartedAt: number,
): void {
  const now = Date.now();
  const pendingIds = new Set(approvals.map((approval) => approval.id));
  const store = ctx.workToastStore.getState();
  for (const item of Object.values(store.items)) {
    if (!item.approval || item.stateChangedAt >= fetchStartedAt || pendingIds.has(item.approval.approvalId)) continue;
    endToolApproval(ctx, item.approval.approvalId);
  }
  for (const approval of approvals) applyToolApprovalRequested({ ...approval }, ctx, now);
}
